<template>
  <div class="status-panel">
    <div v-for="item in statusList" :key="item.title" class="status-card">
      <div class="icon-ring">
        <img src="@/assets/img/gg_icon.png" :alt="item.icon"  />
      </div>
      <div class="status-content">
        <p v-for="line in item.lines" :key="line">
          {{ line }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const statusList = [
  {
    icon: "水",
    title: "运行",
    lines: ["系统运行状态：正常", "当前灌溉面积：1.86万亩"],
  },
  {
    icon: "泵",
    title: "泵站",
    lines: ["在线泵站：42座", "在线阀门：128个", "今日累计用水量：3260吨"],
  },
  {
    icon: "阀",
    title: "阀门",
    lines: ["在线阀门：128个", "今日累计用水量：3260吨"],
  },
];
</script>

<style lang="less" scoped>
.status-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: 0.78fr 1.1fr 1fr;
  row-gap: 20px;
}

.status-card {
  position: relative;
  min-height: 0;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  // background: linear-gradient(135deg, rgba(5, 89, 80, 0.82), rgba(1, 55, 54, 0.96));
  border: 1px solid rgba(105, 255, 244, 0.64);
  border-radius: 10px;
  box-shadow: inset 0 0 40px rgba(83, 255, 241, 0.2),
    0 0 12px rgba(45, 255, 237, 0.12);

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 56px;
    height: 2px;
    background: #70fff6;
    box-shadow: 0 0 12px rgba(112, 255, 246, 0.9);
  }

  &::before {
    left: 18px;
    top: -1px;
  }

  &::after {
    right: 18px;
    bottom: -1px;
  }
}

.icon-ring {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid rgba(90, 255, 242, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 22px;
  box-shadow: inset 0 0 18px rgba(90, 255, 242, 0.22);
  img {
    width: 60px;
    height: 60px;
  }
}

.status-content {
  min-width: 0;

  p {
    margin: 6px 0;
    color: #f7fffc;
    font-size: 30px;
    line-height: 1.25;
    font-weight: bold;
    text-align: left;
    white-space: nowrap;
  }
}
</style>
